const AM_SUBJECT_THEMES = {
  Mathethon: { subject: 'Mathethon', discipline: 'Mathematics', accent: '#E91E63', logo: 'math.png' },
  Physithon: { subject: 'Physithon', discipline: 'Physics', accent: '#2196F3', logo: 'Physics.png' },
  Chemithon: { subject: 'Chemithon', discipline: 'Chemistry', accent: '#4CAF50', logo: 'chemistry.png' },
  Biothon: { subject: 'Biothon', discipline: 'Biology', accent: '#009688', logo: 'biology.png' },
  Inforthon: { subject: 'Inforthon', discipline: 'Informatics', accent: '#9C27B0', logo: 'informatics.png' },
  Envirothon: { subject: 'Envirothon', discipline: 'Asia only', accent: '#2E7D32', logo: 'environthon.png' },
  Econthon: { subject: 'Econthon', discipline: 'Economics', accent: '#FF9800', logo: 'Economics.png' },
  Psychothon: { subject: 'Psychothon', discipline: 'Psychology', accent: '#673AB7', logo: 'psychology.png' },
  Geothon: { subject: 'Geothon', discipline: 'Geography', accent: '#8D6E63', logo: 'geography.png' },
  Historithon: { subject: 'Historithon', discipline: 'History', accent: '#880E4F', logo: 'history.png' },
  Philosothon: { subject: 'Philosothon', discipline: 'Philosophy', accent: '#4A148C', logo: 'philosophy.png' },
  Lingothon: { subject: 'Lingothon', discipline: 'Linguistics', accent: '#FF5252', logo: 'linguistic.png' },
  Artithon: { subject: 'Artithon', discipline: 'Arts', accent: '#E91E78', logo: 'art.png' },
  Literathon: { subject: 'Literathon', discipline: 'Literature', accent: '#1565C0', logo: 'literature.png' }
}

export function resolveAmSubjectTheme(projectCode, fallbackName = 'Academic Marathon') {
  const code = projectCode || ''
  const matchedKey = Object.keys(AM_SUBJECT_THEMES).find(key => code.indexOf(key) !== -1)
  return AM_SUBJECT_THEMES[matchedKey] || {
    subject: fallbackName || 'Academic Marathon',
    discipline: 'Academic Marathon',
    accent: '#FF8C00',
    logo: 'math.png'
  }
}

export { AM_SUBJECT_THEMES }
